import { render, staticRenderFns } from "./UserAddressEdit.vue?vue&type=template&id=2c90bf6b&"
import script from "./UserAddressEdit.vue?vue&type=script&lang=js&"
export * from "./UserAddressEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports